import { CASHOUT_ERROR_CODES } from './mybets-const';
import { TOAST_NOTIFICATION_MESSAGE_STATUS } from 'bto-models/toast-notification';

/**
 * mapper for cashout resp from signalR to toast message types 
 */
export const CASHOUT_TO_TOAST_TYPES = {
  [CASHOUT_ERROR_CODES.SUCCESS]: TOAST_NOTIFICATION_MESSAGE_STATUS.SUCCESS,
  [CASHOUT_ERROR_CODES.ERROR]: TOAST_NOTIFICATION_MESSAGE_STATUS.ERROR,
  [CASHOUT_ERROR_CODES.UNAVAILABLE]: TOAST_NOTIFICATION_MESSAGE_STATUS.WARNING,
  [CASHOUT_ERROR_CODES.NEW_OFFER]: TOAST_NOTIFICATION_MESSAGE_STATUS.WARNING,
};